module.exports = __webpack_public_path__ + "static/media/etapa7.850268d3.svg";